"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _gatsby = require("gatsby");

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var styles = function styles(theme) {
  return {
    root: (0, _defineProperty2.default)({
      display: 'flex',
      justifyContent: 'space-between',
      color: theme.palette.text.secondary,
      fontWeight: 500
    }, "color", theme.palette.text.primary),
    docInfo: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      fontSize: '14px'
    },
    editPage: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      fontSize: '12px'
    }
  };
};

var _ref = _react.default.createElement(_Edit.default, null);

var DocInfo =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DocInfo, _Component);

  function DocInfo() {
    (0, _classCallCheck2.default)(this, DocInfo);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DocInfo).apply(this, arguments));
  }

  (0, _createClass2.default)(DocInfo, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          formattedDate = _this$props.formattedDate,
          category = _this$props.category,
          classes = _this$props.classes,
          isPreview = _this$props.isPreview,
          timeToRead = _this$props.timeToRead,
          slug = _this$props.slug;
      var ADMIN_EDIT_PAGE_URL = '/admin/#/collections/docs/entries/';
      return _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement("div", {
        className: classes.docInfo
      }, _react.default.createElement(_Typography.default, {
        color: "textSecondary"
      }, "Published on ".concat(formattedDate, " - ").concat(timeToRead, " min read")), isPreview ? _react.default.createElement(_Typography.default, {
        color: "textSecondary",
        gutterBottom: true
      }, "In Category ", _react.default.createElement("b", null, category)) : _react.default.createElement(_gatsby.Link, {
        className: "category-link",
        to: "/categories/".concat(_lodash.default.kebabCase(category))
      }, _react.default.createElement(_Typography.default, {
        color: "textSecondary",
        gutterBottom: true
      }, "In Category ", _react.default.createElement("b", null, category)))), _react.default.createElement("div", {
        className: classes.editPage
      }, _react.default.createElement(_Tooltip.default, {
        title: "Edit this Doc",
        placement: "top"
      }, _react.default.createElement(_IconButton.default, {
        href: "".concat(ADMIN_EDIT_PAGE_URL).concat(slug),
        target: "_blank",
        "aria-label": "EditDoc"
      }, _ref))));
    }
  }]);
  return DocInfo;
}(_react.Component);

DocInfo.propTypes = process.env.NODE_ENV !== "production" ? {
  formattedDate: _propTypes.default.string,
  category: _propTypes.default.string
} : {};

var _default = (0, _styles.withStyles)(styles)(DocInfo);

exports.default = _default;